import { Button } from '../../../components/ui/button';
import { GalleryBlock, GiftsBlock, LocationBlock, RsvpBlock, SiteFooter, StoryBlock, renderGalleryByPosition } from '../shared/TemplateBlocks';

export default function BotanicalGardenTemplate(props) {
  const {
    site,
    theme,
    weddingDateLabel,
    daysUntil,
    locationCards,
    availableGifts,
    galleryPosition,
    isTemplatePreview,
    onTemplatePreviewRedirect,
    onOpenRsvp,
    onGiftClick,
    onOpenGallery,
    showCountdown,
    showGiftSection,
    showRsvpCount,
    confirmedGuests
  } = props;

  const heroSupportingTextColor = theme.bannerTextColor || theme.bodyTextColor || '#496358';
  const heroMetaColor = theme.bannerTextColor || theme.locationTitleColor || theme.secondaryColor;

  const galleryNode = (
    <GalleryBlock
      galleryImages={site.gallery_images}
      headingFont={theme.headingFont}
      titleColor={theme.galleryTitleColor || theme.primaryColor}
      secondaryColor={theme.galleryIconColor || theme.secondaryColor}
      sectionBackground={theme.gallerySectionBackground}
      onOpenGallery={onOpenGallery}
      cardClass="rounded-[1.75rem]"
    />
  );

  return (
    <>
      <section className="min-h-[78vh] grid md:grid-cols-2">
        <div className="relative min-h-[320px] md:min-h-[78vh]">
          <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${theme.heroImage})` }} />
          <div className="absolute inset-0" style={{ background: theme.heroOverlay, opacity: theme.heroOverlayOpacity }} />
        </div>
        <div className="px-8 py-14 md:px-12 lg:px-16 flex flex-col justify-center" style={{ background: theme.bannerSectionBackground || '#F3F8F4' }}>
          <p className="text-[0.68rem] uppercase tracking-[0.28em]" style={{ color: heroMetaColor, fontFamily: theme.bannerTextFont }}>Botanical Garden</p>
          <h1 className="mt-4 text-4xl md:text-5xl lg:text-6xl leading-tight" style={{ color: theme.heroTitleColor, fontFamily: theme.bannerTitleFont }}>
            {site.couple_names}
          </h1>
          <p className="mt-4 text-base" style={{ color: heroSupportingTextColor, fontFamily: theme.bannerTextFont }}>{weddingDateLabel}</p>
          {showCountdown ? (
            <p className="mt-5 text-2xl font-light" style={{ color: heroSupportingTextColor, fontFamily: theme.bannerTextFont }}>{daysUntil} dias para celebrar</p>
          ) : null}
          <p className="mt-6 text-sm leading-relaxed" style={{ color: heroSupportingTextColor, fontFamily: theme.bannerTextFont }}>
            Uma celebração com atmosfera natural, leve e intimista. Queremos dividir cada detalhe desse dia com você.
          </p>
          <Button
            onClick={() => (isTemplatePreview ? onTemplatePreviewRedirect?.() : onOpenRsvp?.())}
            className="mt-8 w-fit h-11 rounded-full px-8"
            style={{ background: theme.confirmButtonBackground, color: theme.confirmButtonText, borderColor: theme.confirmButtonBorder, borderWidth: 1, borderStyle: 'solid' }}
          >
            Confirmar Presença
          </Button>
        </div>
      </section>

      {renderGalleryByPosition(galleryPosition, 'after_hero', galleryNode)}

      <StoryBlock
        title="Nossa História"
        storyText={site.story_text}
        background={theme.storySectionBackground || '#FFFFFF'}
        titleColor={theme.storyTitleColor}
        bodyColor={theme.storyBodyColor}
        titleFont={theme.storyTitleFont}
        bodyFont={theme.storyBodyFont}
      />

      {renderGalleryByPosition(galleryPosition, 'after_story', galleryNode)}

      <LocationBlock
        locationCards={locationCards}
        headingFont={theme.headingFont}
        titleFont={theme.locationTitleFont || theme.headingFont}
        titleColor={theme.locationTitleColor}

        textColor={theme.locationTextColor}
        textFont={theme.locationTextFont}
        secondaryColor={theme.secondaryColor}
        sectionBackground={theme.locationSectionBackground || '#F8F6F4'}
        sectionIconColor={theme.locationIconColor || theme.locationTitleColor}
        cardBackground={theme.locationCardBackground}
        cardIconBackground={theme.locationIconColor || theme.locationTitleColor}
        cardTitleColor={theme.locationTitleColor}
        cardLinkColor={theme.locationIconColor || theme.locationTitleColor}
        cardClass="rounded-[1.5rem] border border-[#DDE9E0] bg-white/95 shadow-sm"
      />

      {renderGalleryByPosition(galleryPosition, 'before_gifts', galleryNode)}

      <GiftsBlock
        gifts={availableGifts}
        headingFont={theme.headingFont}
        theme={theme}
        titleColor={theme.primaryColor}
        textColor={theme.bodyTextColor}
        secondaryColor={theme.secondaryColor}
        onGiftClick={onGiftClick}
        showGiftSection={showGiftSection}
      />

      {renderGalleryByPosition(galleryPosition, 'end', galleryNode)}

      <RsvpBlock
        onOpenRsvp={onOpenRsvp}
        isTemplatePreview={isTemplatePreview}
        onTemplatePreviewRedirect={onTemplatePreviewRedirect}
        primaryColor={theme.primaryColor}
        secondaryColor={theme.secondaryColor}
        sectionBackground={theme.rsvpSectionBackground}
        buttonBackground={theme.confirmButtonBackground}
        buttonText={theme.confirmButtonText}
        buttonBorder={theme.confirmButtonBorder}
        iconColor={theme.rsvpIconColor || theme.rsvpTextColor || theme.bodyTextColor}
        titleColor={theme.rsvpTextColor || theme.bodyTextColor}
        bodyColor={theme.rsvpTextColor || theme.bodyTextColor}
        countColor={theme.rsvpTextColor || theme.bodyTextColor}
        headingFont={theme.rsvpTitleFont || theme.headingFont}
        bodyFont={theme.rsvpTextFont}
        showRsvpCount={showRsvpCount}
        confirmedGuests={confirmedGuests}
      />

      <SiteFooter coupleNames={site.couple_names} textColor={theme.bodyTextColor} />
    </>
  );
}

